import { Pipe, PipeTransform } from '@angular/core'
import { Currency } from 'depoto-core/src/entities'

@Pipe({ name: 'formatPrice' })
export class FormatPricePipe implements PipeTransform {
  transform(
    value: number | string,
    currency: Partial<Currency>,
    fractionDigits: number = 2,
    delimiter: string = ',',
  ): string {
    if (!currency?.id) {
      currency = { id: 'CZK' }
    }
    let amount = '0.00'
    const currencySuffix = this.getCurrencySuffix(currency?.id)
    if (!value || (value && Number(value) === 0)) {
      if (
        currency.id === 'EUR' ||
        currency.id === 'USD' ||
        currency.id === 'CAD' ||
        currency.id === 'JPY' ||
        currency.id === 'CHF' ||
        currency.id === 'CNY' ||
        currency.id === 'GBP'
      ) {
        return `${currencySuffix} ${amount}`
      }
      return `${amount} ${currencySuffix}`
    }
    if (typeof value === 'string' && value.includes(' ')) {
      // formatted from other pipes - with thousand separator
      value = value.replaceAll(' ', '')
    }
    amount = Number(value)
      .toFixed(fractionDigits)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    amount = amount.replace('.', delimiter)
    if (currency.id === 'EUR' || currency.id === 'USD' || currency.id === 'GBP') {
      return `${currencySuffix} ${amount}`
    }
    return `${amount} ${currencySuffix}`
  }

  getCurrencySuffix(currencyId: string): string {
    switch (currencyId) {
      default:
      case 'CZK':
        return 'Kč'
      case 'EUR':
        return '€'
      case 'GBP':
        return '£'
      case 'USD':
        return '$'
      case 'RUB':
        return '₽'
      case 'PLN':
        return 'zł'
      case 'CAD':
        return 'C$'
      case 'JPY':
        return '¥'
      case 'RON':
        return 'L'
      case 'HUF':
        return 'Ft'
      case 'HRK':
        return 'Kn'
      case 'CHF':
        return 'Fr'
      case 'CNY':
        return '¥'
    }
  }
}
